import { render, staticRenderFns } from "./SafeDigCommunity.vue?vue&type=template&id=6b6d0afc&scoped=true"
import script from "./SafeDigCommunity.vue?vue&type=script&lang=js"
export * from "./SafeDigCommunity.vue?vue&type=script&lang=js"
import style0 from "./SafeDigCommunity.vue?vue&type=style&index=0&id=6b6d0afc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b6d0afc",
  null
  
)

export default component.exports